import { ReactNode, useMemo } from 'react';
import { QueryClient as V3QueryClient, QueryClientProvider as V3QueryClientProvider } from 'react-query';
import {
  QueryClient as TanstackQueryClient,
  QueryClientProvider as TanstackQueryClientProvider,
} from '@tanstack/react-query';

const TWO_MINUTES = 1000 * 60 * 2;

interface Props {
  children?: ReactNode;
}

/**
 * react-query v3와 @tanstack/react-query v5 클라이언트를 동시에 제공하는 Provider입니다.
 * 기본 staleTime은 2분으로 설정되어 있습니다.
 *
 * - `V3QueryClientProvider`: react-query v3 기반 쿼리 사용처 지원
 * - `TanstackQueryClientProvider`: @tanstack/react-query v5 기반 쿼리 사용처 지원
 *
 * v5 로의 마이그레이션이 완료되면 v3 만 제공 예정입니다.
 */
export const QueryClientProvider = ({ children }: Props) => {
  const v3QueryClient = useMemo(() => {
    return new V3QueryClient({ defaultOptions: { queries: { staleTime: TWO_MINUTES } } });
  }, []);

  const tanstackQueryClient = useMemo(() => {
    return new TanstackQueryClient({ defaultOptions: { queries: { staleTime: TWO_MINUTES } } });
  }, []);

  return (
    <V3QueryClientProvider client={v3QueryClient}>
      <TanstackQueryClientProvider client={tanstackQueryClient}>{children}</TanstackQueryClientProvider>
    </V3QueryClientProvider>
  );
};
